export const Globals = {
    URL: "https://serva.jw29435.de",

    // Admin / superadmin (the superadmin is identified by this fixed email).
    ADMIN_EMAIL: "johannwiebe29@gmail.com",

    // Roles stored as Firebase custom claims on each (non-superadmin) user,
    // alongside a `gemeindeId` claim that scopes them to one Gemeinde.
    ROLE_GEMEINDEADMIN: "gemeindeadmin",
    ROLE_MEMBER: "member",

    // Paths
    PATH_ADMIN: "/admin",
    PATH_DEFAULT: "/",
    PATH_SIMPLE_SUNDAY_SERVICE: "/gottesdienst",
    PATH_SIMPLE_SUNDAY_SERVICE_LIST: "/gottesdienste",
    PATH_SERMON_INFO: "/sermon-info",
    PATH_SWAP: "/tausch",                        // Tauschanfrage beantworten (öffentlich, Token im Pfad)
    PATH_CHOIR_PLAN: "/chor",                   // Dirigenten-Zugang (öffentlich, Token im Pfad)
    PATH_MY_PLAN: "/mein-plan",                 // Persönlicher Prediger-Zugang (öffentlich, Token im Pfad)
    PATH_RECORDING_NAMES: "/gottesdienst-namen",
    PATH_DATENSCHUTZ: "/datenschutz",
    PATH_NUTZUNGSBEDINGUNGEN: "/nutzungsbedingungen",
    PATH_IMPRESSUM: "/impressum",
    PATH_DATA_DELETION_REQUEST: "/datenschutz-anfrage",
    // Top-level, read by the superadmin only (GOD-32).
    DATA_DELETION_REQUESTS_COLLECTION: "dataDeletionRequests",
    // Where people without access can write to (support address of the operator, GOD-43).
    SUPPORT_EMAIL: "support@jw29435.de",
    // One doc per account, written when its claims change (GOD-41).
    ACCOUNT_SIGNALS_COLLECTION: "accountSignals",
    // Multi-tenancy pages
    PATH_SUPERADMIN: "/superadmin",            // Gemeinde-/Nutzerverwaltung (superadmin only)
    PATH_GEMEINDE_SETTINGS: "/gemeinde",        // Gemeinde-Profil & Einstellungen (gemeindeadmin)
    PATH_NO_GEMEINDE: "/keine-gemeinde",        // Halte-Seite für nicht zugeordnete Nutzer

    // --- Multi-tenancy: per-Gemeinde data lives under gemeinden/{gemeindeId}/... ---
    // Top-level collection holding one document per Gemeinde (Standort).
    GEMEINDEN_COLLECTION: "gemeinden",
    // Clean subcollection segment names (no slashes) for building nested paths via
    // collection(db, GEMEINDEN_COLLECTION, gemeindeId, <SUBCOLLECTION>). Use the
    // gemeindeSubPath() helper in services/gemeindePaths.ts to build these.
    PREACHER_SUBCOLLECTION: "preacher",
    ABSENCES_SUBCOLLECTION: "absences",          // unter einem Prediger: gemeinden/{gid}/preacher/{key}/absences
    CHOIRSONG_SUBCOLLECTION: "choirsongs",
    CHOIRSONG_PERFORMANCES_SUBCOLLECTION: "performances",
    SUNDAY_SERVICE_SUBCOLLECTION: "sundayservices",
    FEIERTAGE_SUBCOLLECTION: "feiertage",
    FCM_TOKENS_SUBCOLLECTION: "fcmTokens",
    // Reminder delivery attempts, written by the Cloud Functions (read-only here).
    NOTIFICATION_LOG_SUBCOLLECTION: "notificationLog",
    // Per-Gemeinde notification behaviour: gemeinden/{id}/config/notificationSettings
    GEMEINDE_CONFIG_SUBCOLLECTION: "config",
    // Marker set by the choir backfill: performances carry gemeindeId/year/month.
    CHOIR_INDEX_DOC_ID: "choirIndex",
    NOTIFICATION_SETTINGS_DOC_ID: "notificationSettings",

    // Top-level, superadmin-only: shared channel credentials (SMTP/WhatsApp secrets).
    NOTIFICATION_CONFIG_COLLECTION_KEY: "config",
    NOTIFICATION_CREDENTIALS_DOC_ID: "notificationCredentials",

    // Top-level collections (not per-Gemeinde): tokens carry a gemeindeId field.
    SERMON_NOTIFICATION_TOKENS_COLLECTION_KEY: "sermonNotificationTokens",

    NOTIFICATION_CONFIG_DOC_ID: "notificationSettings",

    // Error messages
    ERROR_AN_ERROR_OCCURED: "Ein Fehler ist aufgetreten.",
    ERROR_INCORRECT_LOGIN: "Deine Anmeldedaten sind nicht korrekt.",
    ERROR_NOT_LOGGED_IN: "Du bist noch nicht angemeldet.",

    // Notifications
    NOTE_SONG_SAVED_SUCCESSFULLY: "Das Lied wurde erfolgreich gespeichert.",
    NOTE_SERMON_SAVED_SUCCESSFULLY: "Die Predigt wurde erfolgreich gespeichert.",
};
